module.exports = __webpack_public_path__ + "static/media/table-w.b086df1b.svg";